import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";
import { GoldButton, GhostButton } from "@/components/common/Buttons";
import { IMAGES } from "@/lib/content";

export function FinalCta() {
  return (
    <section className="relative overflow-hidden py-32 sm:py-44" data-testid="final-cta">
      <div className="absolute inset-0 z-0">
        <img src={IMAGES.welding} alt="Métallurgie — soudure" className="h-full w-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-[#07080B]/85" />
        <div className="absolute inset-0 radial-gold" />
      </div>
      <div className="relative z-10 mx-auto max-w-[1400px] px-5 sm:px-8 text-center">
        <Reveal>
          <div className="eyebrow mb-7 flex items-center justify-center gap-3">
            <span className="h-px w-8 bg-[var(--gold)]/60" /> Une vision à long terme
          </div>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-serif font-light tracking-tight leading-[1.05] text-4xl sm:text-6xl text-white max-w-4xl mx-auto">
            Nous ne construisons pas une succession d'acquisitions.
            <span className="block text-gold mt-2">Nous construisons un groupe.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 max-w-2xl mx-auto text-base sm:text-lg text-slate-300 font-light leading-relaxed">
            Un groupe capable de réunir des entrepreneurs, des techniciens et des entreprises autour d'une vision
            commune : devenir un acteur de référence de la communication visuelle et de ses métiers complémentaires en
            France et en Suisse.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <motion.div className="mt-12">
            <div className="text-chrome font-serif text-3xl tracking-[0.2em]">LOSTA GROUP</div>
            <div className="mt-2 font-serif text-xl text-white/70">Des savoir-faire complémentaires. La force d'un groupe.</div>
          </motion.div>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center">
            <GoldButton to="/ceder-votre-entreprise" testid="final-cta-ceder">
              Céder mon entreprise <ArrowUpRight className="h-4 w-4" />
            </GoldButton>
            <GhostButton to="/contact" testid="final-cta-contact">Contacter Losta Group</GhostButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
